import { useMemo } from 'react';

import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { VisitHistoryShowAnnulledCheckbox } from '../../visitHistory/VisitHistoryShowAnnulledCheckbox/VisitHistoryShowAnnulledCheckbox';

const isVisible = ({ removed, editable }: MedicalInformationAttachment): boolean => !removed || (removed && editable);
const isNotRemoved = ({ removed }: MedicalInformationAttachment): boolean => !removed;

export const useMedicalInformationAttachments = (
   attachments: MedicalInformationAttachment[] | undefined
): MedicalInformationAttachment[] => {
   const [includeAnnulled] = VisitHistoryShowAnnulledCheckbox.useAnnulledVisitsVisibilityPreferenceGlobalState();

   return useMemo(() => {
      if (!Array.isArray(attachments)) {
         return [];
      }

      return attachments.filter(includeAnnulled ? isVisible : isNotRemoved);
   }, [attachments, includeAnnulled]);
};
